const INVOICES = {
  SET_INVOICES_QUERY: 'SET_INVOICES_QUERY',
  SET_INVOICES_INFINITE_QUERY: 'SET_INVOICES_INFINITE_QUERY',
  SET_INVOICE_POSITIONS_QUERY: 'SET_INVOICE_POSITIONS_QUERY',
};

export default INVOICES;
